module.exports = __webpack_public_path__ + "img/-LV58COvq04MtW1sp9CM.8462354c.jpg";